import React from 'react'
import Configurator from '../configurator'
import {
    i18nWrapper,
    withConnectWrapper,
} from '../validator'
import Modal from '../components/shared/modal'
import FoodForm from './food-form'
import {
    database,
    deleteFridgeFood,
    listenData,
    listenDataWithOrderTimestamp,
    setCountFood,
} from '../components/shared/database'
import DatePicker from 'react-date-picker'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import FridgeEatenButton from './fridge/fridge-eaten-button'

class Index extends Configurator {

    state = {
        fridgeModal: false,
        foodFormModal: false,
        fridge: [],
        food: [],
        fridgeFilter: 'fridge',
        unsubscribeListener: () => {},
    }

    componentDidMount() {
        setInterval(() => {
            this.state?.unsubscribeListener?.()
            this.getData()
        }, 6 * 60 * 10 * 1000)

        this.getData()
    }

    getData = () => {
        const dataListener = listenData('food',resultFood => {

            this.setState({ food: resultFood })
            listenDataWithOrderTimestamp('fridge', resultFridge => {
                let resultToFridge = [ ...resultFridge ]
                    .map(fridge => {
                        fridge.food = resultFood.find(stateFood => stateFood.uid === fridge.uidFood)

                        return fridge
                    })

                this.setState({ fridge: resultToFridge })
            })
        })

        this.setState({ unsubscribeListener: dataListener })
    }

    setDateTo = async (date, foodInFridge) => {
        const updateTime = {
            dateTo: date ? window.moment(date).format('L') : null,
            dateToTimestamp: date ? window.moment(date).format('x') : null,
        }

        await database('fridge')
            .doc(foodInFridge.uid)
            .update(updateTime)

        return updateTime
    }

    setOpenedAt = (date, foodInFridge) => {
        database('fridge')
            .doc(foodInFridge.uid)
            .update({
                openedAt: date ? window.moment(date).format('L') : null,
                openedAtTimestamp: date ? window.moment(date).format('x') : null,
            })
    }

    setVacuumAt = (date, foodInFridge) => {
        database('fridge')
            .doc(foodInFridge.uid)
            .update({
                vacuumAt: date ? window.moment(date).format('L') : null,
                vacuumAtTimestamp: date ? window.moment(date).format('x') : null,
                vacuumCount: (foodInFridge?.vacuumCount ?? 0) + 1,
            })
    }
    setFreezerAt = (date, foodInFridge) => {
        database('fridge')
            .doc(foodInFridge.uid)
            .update({
                freezeAt: date ? window.moment(date).format('L') : null,
                freezeAtTimestamp: date ? window.moment(date).format('x') : null,
            })
    }
    setStockedAt = (date, foodInFridge) => {
        database('fridge')
            .doc(foodInFridge.uid)
            .update({
                stockAt: date ? window.moment(date).format('L') : null,
                stockAtTimestamp: date ? window.moment(date).format('x') : null,
            })
    }

    getDaysDiff = foodInFridge => {
        const days = (Number(foodInFridge.dateToTimestamp) - (Number(window.moment().format('x'))) + 24 * 60 * 60 * 1000) / 1000 / 60 / 60 / 24

        return parseFloat(days + '').toFixed(2)
    }

    /**
     * Render
     *
     * @return {*}
     */
    render() {
        const {
            fridge,
            fridgeModal,
            fridgeFilter,
        } = this.state

        const {
            authedUser,
            t,
        } = this.props

        const midnight = new Date()
        midnight.setUTCHours(0, 0, 0, 0)

        return (
            <div className="container d-flex flex-row flex-wrap pt-5">
                <div className="mx-auto w-100">

                    <div>
                        Celkem jídel: <b>{fridge?.length}</b>
                    </div>

                    <div className="d-flex flex-row flex-wrap justify-content-between align-items-center mb-3 ">
                        <Link to="/add" className="btn btn-success">
                            Přidat jídlo do lednice
                        </Link>
                        <Link to="/recipes" className="btn btn-info">
                            Recepty
                        </Link>

                        <div className="d-flex flex-row align-items-center">
                            <div
                                onClick={() => this.setState({ fridgeFilter: null })}
                                className={classNames({
                                    'btn mb-2 d-flex align-items-center': true,
                                    'btn-info': !fridgeFilter,
                                    'btn-outline-info': fridgeFilter,
                                })}
                            >
                                <i className="fas fa-reply-all mr-2"></i>
                                <span style={{ fontSize: '10px' }}>VŠE</span>
                            </div>
                            <div
                                onClick={() => this.setState({ fridgeFilter: 'fridge' })}
                                className={classNames({
                                    'btn mb-2 d-flex align-items-center': true,
                                    'btn-info': fridgeFilter === 'fridge',
                                    'btn-outline-info': fridgeFilter !== 'fridge',
                                })}
                            >
                                <i className="fas fa-temperature-low mr-2"></i>
                                <span style={{ fontSize: '10px' }}>LEDNICE</span>
                            </div>
                            <div
                                onClick={() => this.setState({ fridgeFilter: 'freezer' })}
                                className={classNames({
                                    'btn mb-2 d-flex align-items-center': true,
                                    'btn-info': fridgeFilter === 'freezer',
                                    'btn-outline-info': fridgeFilter !== 'freezer',
                                })}
                            >
                                <i className="fas fa-icicles mr-2"></i>
                                <span style={{ fontSize: '10px' }}>MRAZÁK</span>
                            </div>
                            <div
                                onClick={() => this.setState({ fridgeFilter: 'stock' })}
                                className={classNames({
                                    'btn mb-2 d-flex align-items-center': true,
                                    'btn-info': fridgeFilter === 'stock',
                                    'btn-outline-info': fridgeFilter !== 'stock',
                                })}
                            >
                                <i className="fas fa-layer-group mr-2"></i>
                                <span style={{ fontSize: '10px' }}>SKLAD</span>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex w-100 flex-column">
                        {fridge
                            ?.filter?.(foodInFridge => {
                                if (!fridgeFilter) {
                                    return true
                                }

                                if (fridgeFilter === 'fridge') {
                                    return !foodInFridge?.freezeAtTimestamp && !foodInFridge?.stockAtTimestamp
                                }

                                if (fridgeFilter === 'freezer') {
                                    return !!foodInFridge?.freezeAtTimestamp
                                }

                                if (fridgeFilter === 'stock') {
                                    return !!foodInFridge?.stockAtTimestamp
                                }
                            })
                            ?.map?.((foodInFridge, index) => (
                            <div
                                key={index}
                                className={classNames({
                                    'd-flex flex-row align-items-center justify-content-between p-3 border-bottom flex-wrap w-100': true,
                                    'table-danger text-black': Number(foodInFridge.dateToTimestamp) < (midnight.getTime() - (24 * 60 * 60 * 1000)),
                                    'table-warning text-black': Number(foodInFridge.dateToTimestamp) < midnight.getTime(),
                                    'table-info text-black': Number(foodInFridge.dateToTimestamp) < (midnight.getTime() + (24 * 60 * 60 * 1000)),
                                })}
                            >
                                <div className="align-middle" onClick={() => this.setState({ fridgeModal: foodInFridge })}>
                                    <div className="d-flex flex-column">
                                        <div className="font-micro badge badge-sm badge-secondary badge-pill">
                                            {foodInFridge?.food?.ean}
                                        </div>

                                        <div className="mt-2">
                                            <b>{foodInFridge.name}</b>
                                        </div>
                                    </div>
                                </div>

                                <div className="d-flex flex-row align-items-center justify-content-between mt-3 mt-sm-0 w-100">
                                    <div className="d-flex flex-row flex-wrap align-items-center justify-content-between w-100">
                                        <div style={{ minWidth: '150px' }} className="d-flex flex-row align-items-center justify-content-between">
                                            <div>
                                                Zbývá
                                            </div>
                                            <div>
                                                <b>{this.getDaysDiff(foodInFridge)}</b> dne
                                            </div>
                                        </div>

                                        <div style={{ width: '150px' }} className="d-flex flex-column align-items-center justify-content-start">
                                            <div className="font-micro d-flex flex-row align-items-center justify-content-between w-100">
                                                <b>Koupeno: </b>
                                                <div>
                                                    {foodInFridge.buyAt}
                                                </div>
                                            </div>

                                            <div className="font-micro d-flex flex-row align-items-center justify-content-between w-100">
                                                <b>SNÍST: </b>
                                                <div>
                                                    {foodInFridge.dateTo}
                                                </div>
                                            </div>

                                            {foodInFridge?.openedAtTimestamp && (
                                                <div className="font-micro text-danger d-flex flex-row align-items-center justify-content-between w-100">
                                                    <b>OTEVŘENO: </b>
                                                    <div>
                                                        {new Date(Number(foodInFridge?.openedAtTimestamp)).toLocaleDateString()}
                                                    </div>
                                                </div>
                                            )}

                                            {foodInFridge?.vacuumAtTimestamp && (
                                                <div className="font-micro text-danger d-flex flex-row align-items-center justify-content-between w-100">
                                                    <b>VAKUUM: </b>
                                                    <div>
                                                        {new Date(Number(foodInFridge?.vacuumAtTimestamp)).toLocaleDateString()} ({foodInFridge?.vacuumCount})
                                                    </div>
                                                </div>
                                            )}

                                            {(foodInFridge?.countFood ?? 1) > 1 && (
                                                <div className="font-micro text-info d-flex flex-row align-items-center justify-content-between w-100">
                                                    <b>KUSŮ: </b>
                                                    <div>
                                                        {foodInFridge?.countFood ?? 1}
                                                    </div>
                                                </div>
                                            )}

                                            {foodInFridge?.freezeAtTimestamp && (
                                                <div className="font-micro text-info d-flex flex-row align-items-center justify-content-between w-100">
                                                    <b>MRAZÁK: </b>
                                                    <div>
                                                        {new Date(Number(foodInFridge?.freezeAtTimestamp)).toLocaleDateString()}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="d-flex flex-column ml-3 pl-3" style={{ borderLeft: '1px solid black' }}>
                                        <div className="d-flex align-items-center justify-content-between">
                                            <button
                                                onClick={() => this.setOpenedAt(foodInFridge?.openedAtTimestamp ? null : new Date, foodInFridge)}
                                                className={classNames({
                                                    'btn mb-2': true,
                                                    'btn-info': foodInFridge?.openedAtTimestamp,
                                                    'btn-outline-info': !foodInFridge?.openedAtTimestamp,
                                                })}
                                            >
                                                <i className="far fa-envelope-open"></i>
                                                <div style={{ fontSize: '8px' }}>
                                                    OTEVŘEN
                                                </div>
                                            </button>


                                            <button
                                                onClick={() => this.setVacuumAt(new Date, foodInFridge)}
                                                className={classNames({
                                                    'btn mb-2': true,
                                                    'btn-info': foodInFridge?.vacuumAtTimestamp,
                                                    'btn-outline-info': !foodInFridge?.vacuumAtTimestamp,
                                                })}
                                            >
                                                <i className="fas fa-wind"></i>
                                                <div style={{ fontSize: '8px' }}>
                                                    VAKUUM
                                                </div>
                                            </button>


                                            <button
                                                onClick={() => this.setFreezerAt(foodInFridge?.freezeAtTimestamp ? null : new Date, foodInFridge)}
                                                className={classNames({
                                                    'btn mb-2': true,
                                                    'btn-info': foodInFridge?.freezeAtTimestamp,
                                                    'btn-outline-info': !foodInFridge?.freezeAtTimestamp,
                                                })}
                                            >
                                                <i className="fas fa-icicles"></i>
                                                <div style={{ fontSize: '8px' }}>
                                                    MRAZÁK
                                                </div>
                                            </button>


                                            <button
                                                onClick={() => this.setStockedAt(foodInFridge?.stockAtTimestamp ? null : new Date, foodInFridge)}
                                                className={classNames({
                                                    'btn mb-2': true,
                                                    'btn-info': foodInFridge?.stockAtTimestamp,
                                                    'btn-outline-info': !foodInFridge?.stockAtTimestamp,
                                                })}
                                            >
                                                <i className="fas fa-layer-group"></i>
                                                <div style={{ fontSize: '8px' }}>
                                                    SKLAD
                                                </div>
                                            </button>
                                        </div>
                                        <FridgeEatenButton foodInFridge={foodInFridge} />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {fridgeModal && (
                        <Modal
                            description={fridgeModal?.name}
                            handleHideModal={() => this.setState({ fridgeModal: null })}
                            content={() => (
                                <div className="p-3">
                                    {fridgeModal?.description && (
                                        <div>
                                            Popis:

                                            <div className="p-3" dangerouslySetInnerHTML={{ __html: fridgeModal?.description }} />
                                        </div>
                                    )}

                                    <div className="d-flex flex-row align-items-center justify-content-between">
                                        <div className="d-flex flex-row align-items-center">
                                            <div className="mr-1">
                                                Počet kusů:
                                            </div>
                                            <div className="mr-2">
                                                {fridgeModal?.countFood}
                                            </div>
                                        </div>
                                        <div className="btn btn-group" style={{ width: '50%' }}>
                                            <div
                                                className="btn btn-secondary"
                                                onClick={() => {
                                                    setCountFood(fridgeModal.uid, '-')
                                                        .then(newCountFood => this.setState({ fridgeModal: { ...fridgeModal, countFood: newCountFood }}))
                                                }}
                                            >
                                                -
                                            </div>
                                            <div
                                                className="btn btn-secondary"
                                                onClick={() => {
                                                    setCountFood(fridgeModal.uid, '+')
                                                        .then(newCountFood => this.setState({ fridgeModal: { ...fridgeModal, countFood: newCountFood }}))
                                                }}
                                            >
                                                +
                                            </div>
                                        </div>
                                    </div>

                                    <div className="d-flex flex-row align-items-center justify-content-between">
                                        <div className="d-flex flex-row align-items-center">
                                            <div className="mr-1">
                                                Sníst do:
                                            </div>
                                            <div className="mr-2">
                                                {fridgeModal?.dateTo}
                                            </div>
                                        </div>
                                        <div className="btn btn-group" style={{ width: '50%' }}>
                                            <div
                                                className="btn btn-secondary"
                                                onClick={() => {
                                                    this.setDateTo(new Date(Number(fridgeModal.dateToTimestamp) - 1000 * 60 * 60 * 24), fridgeModal)
                                                        .then(updateTime => {
                                                            this.setState({
                                                                fridgeModal: {
                                                                    ...fridgeModal,
                                                                    dateTo: updateTime.dateTo,
                                                                    dateToTimestamp: updateTime.dateToTimestamp,
                                                                }})
                                                        })
                                                }}
                                            >
                                                - den
                                            </div>
                                            <div
                                                className="btn btn-secondary"
                                                onClick={() => {
                                                    this.setDateTo(new Date(Number(fridgeModal.dateToTimestamp) + 1000 * 60 * 60 * 24), fridgeModal)
                                                        .then(updateTime => {
                                                            this.setState({
                                                                fridgeModal: {
                                                                    ...fridgeModal,
                                                                    dateTo: updateTime.dateTo,
                                                                    dateToTimestamp: updateTime.dateToTimestamp,
                                                                }})
                                                        })
                                                }}
                                            >
                                                + den
                                            </div>
                                            <div
                                                className="btn btn-secondary"
                                                onClick={() => {
                                                    this.setDateTo(new Date(Number(fridgeModal.dateToTimestamp) + 1000 * 60 * 60 * 24 * 7), fridgeModal)
                                                        .then(updateTime => {
                                                            this.setState({
                                                                fridgeModal: {
                                                                    ...fridgeModal,
                                                                    dateTo: updateTime.dateTo,
                                                                    dateToTimestamp: updateTime.dateToTimestamp,
                                                                }})
                                                        })
                                                }}
                                            >
                                                + týden
                                            </div>
                                            <div
                                                className="btn btn-secondary"
                                                onClick={() => {
                                                    this.setDateTo(new Date(), fridgeModal)
                                                        .then(updateTime => {
                                                            this.setState({
                                                                fridgeModal: {
                                                                    ...fridgeModal,
                                                                    dateTo: updateTime.dateTo,
                                                                    dateToTimestamp: updateTime.dateToTimestamp,
                                                                }})
                                                        })
                                                }}
                                            >
                                                dnes
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            dialogClass="modal-lg"
                        />
                    )}
                </div>
            </div>
        )
    }
}

export default withConnectWrapper(state => ({
}))(i18nWrapper(Index))
